import { Component, Input } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DocumentsComponent } from './documents/documents.component';

@Component({
  selector: 'app-disclosure',
  templateUrl: './disclosure.component.html',
  styleUrls: ['./disclosure.component.scss'],
  standalone: false,
})
export class DisclosureComponent {
  @Input() disclosure: any = {};
  @Input() slug: any = '';
  schoolSlug: string = this.slug;
  constructor(private dialog: MatDialog) {}

  isPublicDisclosureVisible: boolean = false;

  openDialog(): void {
    const dialogRef = this.dialog.open(DocumentsComponent, {
      disableClose: true,
      position: {
        top: '0px',
        right: '0px',
      },
      data: {
        slug: this.slug,
        disclosure: this.disclosure,
      },
    });
  }

  showPublicDisclosure(): void {
    this.isPublicDisclosureVisible = true;
  }

  hidePublicDisclosure(): void {
    this.isPublicDisclosureVisible = false;
  }
}
